export enum ProductionScheduleListviewColumnType {
  NAME,
  STATUS,
  QUANTITY,
  WIDTH,
  HEIGHT,
  TOTAL_WOVEN_HEIGHT,
  COLOR_MAIN,
  COLOR_BORDER,
  FINISHING_AND_CUTBARS_LABEL,
  SHAPE,
  PRODUCTION,
  EDIT,
  OPEN_IN_CADCAM
}
